import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 71.4 50",
  width: "71",
  height: "50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { transform: "scale(0.58823529 0.58823529)" }, [
      _createElementVNode("path", {
        class: "__st0",
        d: "M118.9 13.3C117.5 8.1 113.4 4 108.2 2.6 98.7 0 60.7 0 60.7 0 60.7 0 22.7 0 13.2 2.5 8.1 3.9 3.9 8.1 2.5 13.3 0 22.8 0 42.5 0 42.5 0 42.5 0 62.3 2.5 71.7 3.9 76.9 8 81 13.2 82.4 22.8 85 60.7 85 60.7 85c0 0 38 0 47.5-2.5 5.2-1.4 9.3-5.5 10.7-10.7 2.5-9.5 2.5-29.2 2.5-29.2 0 0 0.1-19.8-2.5-29.3z",
        fill: "#f00"
      }),
      _createElementVNode("polygon", {
        class: "__st1",
        points: "80.2 42.5 48.6 24.3 48.6 60.7 ",
        fill: "#fff"
      })
    ], -1)
  ])))
}
export default { render: render }